import axios from 'axios';
import { Fetcher } from 'openapi-typescript-fetch';
import { CustomRequestInit, Fetch } from 'openapi-typescript-fetch/dist/esm/types';

import { importMetaEnv } from '~sf/constants';

import type { ApiPaths } from '.';

export const API_URL = importMetaEnv.VITE_API_URL || 'http://localhost:8003';

export const fetcher = Fetcher.for<ApiPaths>();

// eslint-disable-next-line functional/immutable-data
axios.defaults.withCredentials = true;

fetcher.configure({
  baseUrl: API_URL,
});

fetcher.use(async (url: string, init: CustomRequestInit, next: Fetch) => {
  // eslint-disable-next-line functional/immutable-data
  init.credentials = 'include';

  return next(url, init);
});
